import { InjectionToken } from "@angular/core";
import * as moment from "moment";
import { environment } from "../environments/environment";
import {StoreService} from "@root/shared/service/store.service";
// --------------------------
// ---------全局常量----------
// --------------------------

export const VERSION = environment.version;

export const INTERNATIONAL = environment.international;

/** 分享微店的url */
export const URL_CONFIG = {
  h5_shop_url: environment.h5_shop_url,
  web_url: environment.web_url,
};

export enum ERROR_CODE {
  SUCCESS = 0,
  USER_IN_REVIEW = 200000,
  INVALID_PHONE_NUMBER = 200004,
  USER_AUTH_FAILED = 210001,
  USER_NEED_FINISH_INFO = 210002,
  PICTURE_IMAGE_ERROR = 220000,
  NO_AUTHORITY = 220001,
  USER_ALREADY_REGISTE = 200003,
  CODE_TOO_MANY_ATTAMPTS = 200001,
  CODE_SYNCER_HOUSE_FAILED = 211000,
  CODE_THIRDPARTY_LOGIN_FAIL = 213000,
  AIRBNB_NEED_VERIFICATION_FOR_LOGIN = 213001,
  BOOKING_NEED_VERIFICATION_FOR_LOGIN = 213003,
  ZHENGUO_NEED_VERIFICATION_FOR_LOGIN = 213004,
  AIRBNB_NEED_GEETEST_VERIFY_FOR_LOGIN = 213005,
  CODE_OPERATOR_MESSAGE_NOT_FOUND = 240000,
  CODE_NO_USER_WHEN_RESET_PASSWORD = 400002,
  CODE_WRONG_WHEN_RESET_PASSWORD = 400001,
  CODE_IMAGE_CODE_WRONG_WHEN_RESET_PASSWORD = 400000,
  CODE_PRODUCT_EXPIRED = 60000,
}

export enum PLATFORM_TYPE {
  AIRBNB = 0,
  TUJIA = 1,
  XIAOZHU = 2,
  YIJIA = 3,
  MAYI = 4,
  PLATFORM = 5, // 手工订单
  SHOP = 6,
  ZHENGUO = 7,
  MUNIAO = 8,
  BOOKING = 9,
  TUJIAGYS = 10,
  CTRIP = 11,
  MEITUAN = 12, // 美团酒店
  FLIGGY = 13, // 飞猪
  ZHUDD = 14, // 住多多
  HOMEAWAY = 15, // homeway
  AGODA = 16, // agoda
  EXPEDIA = 17,
  ASIAYO = 18,
  WAKA = 19,
  VRBO = 20,
  ZHUKEYUN = 21, // 住客云
}

// 边框颜色：住多多：#E32524，homeaway：#0851A3，agoda：#5392F9
export interface IPlatform {
  type: PLATFORM_TYPE;
  name: string;
  icon: string;
  icon_color: string;
  icon_gray: string;
  [propName: string]: any;
}
export const PLATFORM_TYPE_INFO: Record<PLATFORM_TYPE, IPlatform> = {
  [PLATFORM_TYPE.AIRBNB]: {
    type: PLATFORM_TYPE.AIRBNB,
    name: "爱彼迎",
    icon: "/assets/new_icon/airbnb.png",
    icon_color: "/assets/new_icon/airbnb_color.png",
    icon_gray: "/assets/new_icon/airbnb_gray.png",
    user_page_url: "https://www.airbnb.com/users/show/@@@@",
    style: {
      border: "1px solid #FF6766",
    },
    show: true,
    intlShow: true,
    order: 2,
    desc: "官方直连 | 渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.TUJIA]: {
    type: PLATFORM_TYPE.TUJIA,
    name: "途家",
    icon: "/assets/new_icon/tujia.png",
    icon_color: "/assets/new_icon/tujia_color.png",
    icon_gray: "/assets/new_icon/tujia_gray.png",
    user_page_url:
      "https://guanjia.tujia.com/storemanagement/landlordpage/?customerLoginID=@@@@",
    style: {
      border: "1px solid #FE4A0B",
    },
    show: true,
    intlShow: false,
    order: 3,
    desc: "直连模式 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.XIAOZHU]: {
    type: PLATFORM_TYPE.XIAOZHU,
    name: "小猪短租",
    icon: "/assets/new_icon/xiaozhu_new.png",
    icon_color: "/assets/new_icon/xiaozhu_new_color.png",
    icon_gray: "/assets/new_icon/xiaozhu_new_gray.png",
    user_page_url: "http://www.xiaozhu.com/fangke/@@@@/",
    style: {
      border: "1px solid #EB5C74",
    },
    show: true,
    intlShow: false,
    order: 5,
    desc: "直连模式 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.YIJIA]: {
    type: PLATFORM_TYPE.YIJIA,
    name: "一家民宿",
    icon: "/assets/new_icon/yijia.png",
    icon_color: "/assets/new_icon/yijia_color.png",
    icon_gray: "/assets/new_icon/yijia_gray.png",
    user_page_url: "http://www.onehome.me/user/p_show?id=@@@@",
    style: {
      border: "1px solid #EB5C74",
    },
    show: true,
    intlShow: false,
    order: 8,
    desc: "直连模式 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.MAYI]: {
    type: PLATFORM_TYPE.MAYI,
    name: "蚂蚁",
    icon: "/assets/new_icon/yijia.png",
    icon_color: "/assets/new_icon/yijia_color.png",
    icon_gray: "/assets/new_icon/yijia_gray.png",
    user_page_url: "http://www.onehome.me/user/p_show?id=@@@@",
    style: {
      border: "1px solid #EB5C74",
    },
    show: false,
    intlShow: false,
    order: 10,
    desc: "直连模式 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.PLATFORM]: {
    type: PLATFORM_TYPE.PLATFORM,
    name: "百居易",
    icon: "/assets/icon/icon_default_platform.png",
    icon_color: "/assets/icon/icon_default_platform.png",
    icon_gray: "/assets/icon/icon_default_platform.png",
    user_page_url: "",
    show: false,
    intlShow: false,
    order: 100,
    desc: "",
  },
  [PLATFORM_TYPE.SHOP]: {
    type: PLATFORM_TYPE.SHOP,
    name: "民宿微店",
    // icon: '/assets/icon/icon_shop.svg',
    icon: "/assets/new_icon/hostex_shop.png",
    // icon_color: '/assets/icon/icon_shop_color.svg',
    icon_color: "/assets/new_icon/hostex_shop_color.png",
    icon_gray: "/assets/new_icon/hostex_shop_gray.png",
    user_page_url: "",
    show: true,
    intlShow: false,
    order: 10,
    desc:
      "房东自有渠道 | 免佣金支出 | 以小程序、H5展示给房客 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.ZHENGUO]: {
    type: PLATFORM_TYPE.ZHENGUO,
    name: "美团民宿",
    icon: "/assets/new_icon/zhenguo.png",
    icon_color: "/assets/new_icon/zhenguo_color.png",
    icon_gray: "/assets/new_icon/zhenguo_gray.png",
    user_page_url: "https://www.zhenguo.com/user/@@@@/",
    show: true,
    intlShow: false,
    order: 1,
    desc: "官方直连 | 房态房价管理 | 订单管理 | 聊天管理（账号密码登录）",
  },
  [PLATFORM_TYPE.MUNIAO]: {
    type: PLATFORM_TYPE.MUNIAO,
    name: "木鸟短租",
    icon: "/assets/new_icon/muniao.png",
    icon_color: "/assets/new_icon/muniao_color.png",
    icon_gray: "/assets/new_icon/muniao_gray.png",
    user_page_url: "",
    style: {
      border: "1px solid #C7A05C",
    },
    show: true,
    intlShow: false,
    order: 6,
    desc: "直连模式 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.BOOKING]: {
    type: PLATFORM_TYPE.BOOKING,
    name: "缤客Booking",
    icon: "/assets/new_icon/booking.png",
    icon_color: "/assets/new_icon/booking_color.png",
    icon_gray: "/assets/new_icon/booking_gray.png",
    user_page_url: "",
    style: {
      border: "1px solid #023581",
    },
    show: true,
    intlShow: true,
    order: 9,
    desc: "订单同步 | 自动关房 | 房态房价管理",
  },
  [PLATFORM_TYPE.TUJIAGYS]: {
    type: PLATFORM_TYPE.TUJIAGYS,
    name: "途家供应商",
    icon: "/assets/new_icon/tujiaGYS.png",
    icon_color: "/assets/new_icon/tujiaGYS_color.png",
    icon_gray: "/assets/new_icon/tujiaGYS_gray.png",
    user_page_url:
      "https://guanjia.tujia.com/storemanagement/landlordpage/?customerLoginID=@@@@",
    show: true,
    intlShow: false,
    order: 10,
    desc:
      "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.CTRIP]: {
    type: PLATFORM_TYPE.CTRIP,
    name: "携程",
    icon: "/assets/new_icon/ctrip.png",
    icon_color: "/assets/new_icon/ctrip_color.png",
    icon_gray: "/assets/new_icon/ctrip_gray.png",
    user_page_url: "",
    style: {
      border: "1px solid #2677E3",
    },
    show: true,
    intlShow: false,
    order: 4,
    desc: "订单同步 | 自动关房 | 房态房价管理",
  },
  [PLATFORM_TYPE.MEITUAN]: {
    type: PLATFORM_TYPE.MEITUAN,
    name: "美团",
    icon: "/assets/new_icon/meituan.png",
    icon_color: "/assets/new_icon/meituan_color.png",
    icon_gray: "/assets/new_icon/meituan_gray.png",
    user_page_url:
      "https://guanjia.tujia.com/storemanagement/landlordpage/?customerLoginID=@@@@",
    style: {
      border: "1px solid #efb72a",
    },
    show: true, // 测试环境
    // show: false, // 上线环境
    intlShow: false,
    order: 10,
    desc: "官方直连 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.FLIGGY]: {
    type: PLATFORM_TYPE.FLIGGY,
    name: "飞猪",
    icon: "/assets/new_icon/fliggy.png",
    icon_color: "/assets/new_icon/fliggy_color.png",
    icon_gray: "/assets/new_icon/fliggy_gray.png",
    user_page_url:
      "https://guanjia.tujia.com/storemanagement/landlordpage/?customerLoginID=@@@@",
    style: {
      border: "1px solid #F5AA13",
    },
    show: true,
    intlShow: false,
    order: 7,
    desc: "订单同步 | 自动关房 | 房态房价管理",
  },
  [PLATFORM_TYPE.ZHUDD]: {
    type: PLATFORM_TYPE.ZHUDD,
    name: "住多多",
    icon: "/assets/new_icon/zhuduoduo.png",
    icon_color: "/assets/new_icon/zhuduoduo_color.png",
    icon_gray: "/assets/new_icon/zhuduoduo_gray.png",
    user_page_url: "",
    style: {
      border: "1px solid #E32524",
    },
    // show: true, // 测试环境
    show: false, // 上线环境
    intlShow: false,
    order: 10,
    desc:
      "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.HOMEAWAY]: {
    type: PLATFORM_TYPE.HOMEAWAY,
    name: "HomeAway/Vrbo",
    icon: "/assets/new_icon/homeaway.png",
    icon_color: "/assets/new_icon/homeaway_color.png",
    icon_gray: "/assets/new_icon/homeaway_gray.png",
    user_page_url: "",
    style: {
      border: "1px solid #0851A3",
    },
    // show: true, // 测试环境
    show: false, // 上线环境
    intlShow: false,
    order: 10,
    desc:
      "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.AGODA]: {
    type: PLATFORM_TYPE.AGODA,
    name: "Agoda",
    icon: "/assets/new_icon/agoda.png",
    icon_color: "/assets/new_icon/agoda_color.png",
    icon_gray: "/assets/new_icon/agoda_gray.png",
    user_page_url: "",
    style: {
      border: "1px solid #5392F9",
    },
    // show: true, // 测试环境
    show: true, // 上线环境
    intlShow: true,
    order: 10,
    desc:
      "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.EXPEDIA]: {
    type: PLATFORM_TYPE.EXPEDIA,
    name: "Expedia",
    icon: "/assets/new_icon/expedia.png",
    icon_color: "/assets/new_icon/expedia_color.png",
    icon_gray: "/assets/new_icon/expedia_gray.png",
    user_page_url: "",
    style: {
      border: "1px solid #062B49",
    },
    // show: true, // 测试环境
    show: false, // 上线环境
    intlShow: false,
    order: 10,
    desc:
      "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.ASIAYO]: {
    type: PLATFORM_TYPE.ASIAYO,
    name: "AsiaYo",
    icon: "/assets/new_icon/asiayo.png",
    icon_color: "/assets/new_icon/asiayo_color.png",
    icon_gray: "/assets/new_icon/asiayo_gray.png",
    user_page_url: "",
    style: {
      border: "1px solid #69C5E0",
    },
    // show: true, // 测试环境
    show: false, // 上线环境
    intlShow: false,
    order: 10,
    desc:
      "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.WAKA]: {
    type: PLATFORM_TYPE.WAKA,
    name: "WaKa",
    icon: "/assets/new_icon/waka.png",
    icon_color: "/assets/new_icon/waka_color.png",
    icon_gray: "/assets/new_icon/waka_gray.png",
    user_page_url: "",
    style: {
      border: "1px solid #FF9100",
    },
    // show: true, // 测试环境
    show: false, // 上线环境
    intlShow: false,
    order: 10,
    desc:
      "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PLATFORM_TYPE.VRBO]: {
    type: PLATFORM_TYPE.VRBO,
    name: 'Vrbo',
    icon: "/assets/new_icon/vrbo_color.png",
    icon_color: "/assets/new_icon/vrbo_color.png",
    icon_gray: "/assets/new_icon/vrbo_color.png",
    show: false,
    intlShow: true,
  },
  [PLATFORM_TYPE.ZHUKEYUN]: {
    type: PLATFORM_TYPE.ZHUKEYUN,
    name: '高级微店（住客云）',
    icon: "/assets/new_icon/zhukeyun.png",
    icon_color: "/assets/new_icon/zhukeyun_color.png",
    icon_gray: "/assets/new_icon/zhukeyun_gray.png",
    show: true,
    desc: "房东自有渠道 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理"
  }
};

export const OATH_STATUS = {
  NO_AUTH: 0,
  SUCCESS: 1,
  OUTDATE: -1,
};

export const SYNC_STATUS = {
  UNLINKED: -3, // 断开连接  airbnb直连才有
  REJECTED: -2, // 审核失败
  REVIEWING: -1, // 审核中
  DOING: 0, // 同步中
};

// event-bus 事件类型
/**
 * @deprecated
 */
export enum EVENT_TYPE {
  LOADING = 0, // 加载事件
  CALENDAR = 1, // 日历事件
  GROUPS = 2, // 全部组别,
  RESIZE = 3, // 窗口resize事件,
  MODAL = 4, // 自定义modal,
  DATE_CHANGE = 5, // status组件日期变化时触发
  MESSAGE = 6, // 消息相关,
  ROUTE_CHANGE = 7,
  REFRESH = 9, // 刷新相关接口
  AJAX = 10,
  MENU_UPDATE = 11, // 刷新左边菜单
  SHOW_UPDATE = 12, // 显示更新弹窗
  SHOW_QRCODE = 13,
  UPDATE_HOUSE_CALENDAR_PRICE = 14, // 更新单房源房态的价格
  UPDATE_SYNCED_ACCOUNTS = 15, // 更新同步到的账号
  UPDATE_CHANGE_LAST_MESSAGE_TIME = 16, // 更新上一次同步时间。
  PUSH_THIRDPARTY_CALENDAR = 17,
  UPDATE_CALENAR_ORDER_INFO = 18, // 在房态页面当取消订单时重新拉取
  RESET_BREADCRUMB = 19,
}

// 房源类型
export enum HOUSE_TYPE {
  APARTMENT = 1, // 住宅公寓
  INDEPENDENT_VILLA = 2, // 独栋别墅
  HOTEL_APARTMENT = 3, // 酒店式公寓
  INN = 4, // 客栈
  AGRITAINMENT = 5, // 农家乐
  VILLA_ROOM = 6, // 别墅单间
  TOWNHOUSE = 7, // 联排别墅
  OLD_VILLA = 8, // 老洋房
  COURTYARD = 9, // 四合院
  FISHING_ROOM = 10, // 渔家乐
  CABIN = 11, // 木屋
  CAMPER_RV = 12, // 房车
  YURT = 13, // 蒙古包
  STILT_HOUSE = 14, // 吊脚楼
  TULOU = 15, // 土楼
  CONTAINER = 16, // 集装箱
  ROCK_HOUSE = 17, // 石屋
  TREEHOUSE = 18, // 树屋
  YACHT = 19, // 游艇
  DUPLEX_LOFT = 20, // Loft复式
  BOATHOUSE = 21, // 船屋
  BAMBOO_HOUSE = 22, // 竹屋
  SEMI_DETACHED_VILLA = 23, // 叠拼别墅
  WATCHTOWER = 24, // 碉楼
  CAVE_DWELLING = 25, // 窑洞
  TENT = 26, // 帐篷营地
  RESORT = 27, // 度假村
  HANOK = 28, // 韩屋
  RYOKAN = 29, // 日式旅馆
  OTHERS = 30, // 其他
  ATTIC = 31, // 阁楼
  BEACH_HOUSE = 32, // 海边小屋
  FOREST_HOUSE = 33, // 林间小屋
  CASTLE = 34, // 城堡
}

export const HOUSE_TYPE_DESC = {
  // [HOUSE_TYPE.UNKNOWN]: '未知类型',
  [HOUSE_TYPE.APARTMENT]: "住宅公寓",
  [HOUSE_TYPE.TOWNHOUSE]: "联排别墅",
  [HOUSE_TYPE.DUPLEX_LOFT]: "Loft复式",
  [HOUSE_TYPE.COURTYARD]: "四合院",
  [HOUSE_TYPE.INDEPENDENT_VILLA]: "独栋别墅",
  [HOUSE_TYPE.SEMI_DETACHED_VILLA]: "叠拼别墅",
  [HOUSE_TYPE.CAMPER_RV]: "房车",
  [HOUSE_TYPE.TULOU]: "土楼",
  [HOUSE_TYPE.YURT]: "蒙古包",
  [HOUSE_TYPE.STILT_HOUSE]: "吊脚楼",
  [HOUSE_TYPE.WATCHTOWER]: "碉楼",
  [HOUSE_TYPE.CAVE_DWELLING]: "窑洞",
  [HOUSE_TYPE.CABIN]: "木屋",
  [HOUSE_TYPE.TREEHOUSE]: "树屋",
  [HOUSE_TYPE.BAMBOO_HOUSE]: "竹屋",
  [HOUSE_TYPE.TENT]: "帐篷营地",
  [HOUSE_TYPE.YACHT]: "游艇",
  [HOUSE_TYPE.OLD_VILLA]: "老洋房",
  [HOUSE_TYPE.HOTEL_APARTMENT]: "酒店式公寓",
  [HOUSE_TYPE.VILLA_ROOM]: "别墅单间",
  [HOUSE_TYPE.FISHING_ROOM]: "渔家乐",
  [HOUSE_TYPE.BOATHOUSE]: "船屋",
  [HOUSE_TYPE.AGRITAINMENT]: "农家乐",
  [HOUSE_TYPE.INN]: "客栈",
  [HOUSE_TYPE.RESORT]: "度假村",
  [HOUSE_TYPE.CONTAINER]: "集装箱",
  [HOUSE_TYPE.ROCK_HOUSE]: "石屋",
  [HOUSE_TYPE.HANOK]: "韩屋",
  [HOUSE_TYPE.RYOKAN]: "日式旅馆",
  [HOUSE_TYPE.OTHERS]: "其他",
  [HOUSE_TYPE.ATTIC]: "阁楼",
  [HOUSE_TYPE.BEACH_HOUSE]: "海边小屋",
  [HOUSE_TYPE.FOREST_HOUSE]: "林间小屋",
  [HOUSE_TYPE.CASTLE]: "城堡",
};

export enum TUJIA_HOUSE_TYPE {
  APARTMENT = 1, // 普通公寓
  TOWNHOUSE = 2, // 联排别墅
  DUPLEX_LOFT = 3, // Loft复式
  COURTYARD = 4, // 四合院
  INDEPENDENT_VILLA = 7, // 独栋别墅
  SEMI_DETACHED_VILLA = 8, // 叠拼别墅
  CAMPER_RV = 10, // 房车营地
  TULOU = 11, // 土楼
  YURT = 12, // 蒙古包
  STILT_HOUSE = 13, // 吊脚楼
  WATCHTOWER = 14, // 碉楼
  CAVE_DWELLING = 15, // 窑洞
  CABIN = 16, // 木屋
  TREEHOUSE = 17, // 树屋
  BAMBOO_HOUSE = 18, // 竹屋
  TENT = 19, // 帐篷营地
  YACHT = 21, // 游艇
  OLD_VILLA = 22, // 老洋房
  HOTEL_APARTMENT = 23, // 酒店式公寓
  VILLA_ROOM = 25, // 别墅单间
  FISHING_ROOM = 26, // 渔家乐
  BOATHOUSE = 27, // 船屋
  AGRITAINMENT = 28, // 农家乐
  INN = 29, // 客栈
  RESORT = 31, // 度假村
  CONTAINER = 34, // 集装箱
  ROCK_HOUSE = 35, // 石屋
  HANOK = 36, // 韩屋
  RYOKAN = 37, // 日式旅馆
  OTHERS = 38, // 其他
  ATTIC = 39, // 阁楼
  BEACH_HOUSE = 40, // 海边小屋
  FOREST_HOUSE = 41, // 林间小屋
  CASTLE = 42, // 城堡
}
export const TUJIA_HOUSE_TYPE_DESC = {
  [TUJIA_HOUSE_TYPE.APARTMENT]: "普通公寓",
  [TUJIA_HOUSE_TYPE.TOWNHOUSE]: "联排别墅",
  [TUJIA_HOUSE_TYPE.DUPLEX_LOFT]: "Loft复式",
  [TUJIA_HOUSE_TYPE.COURTYARD]: "四合院",
  [TUJIA_HOUSE_TYPE.INDEPENDENT_VILLA]: "独栋别墅",
  [TUJIA_HOUSE_TYPE.SEMI_DETACHED_VILLA]: "叠拼别墅",
  [TUJIA_HOUSE_TYPE.CAMPER_RV]: "房车营地",
  [TUJIA_HOUSE_TYPE.TULOU]: "土楼",
  [TUJIA_HOUSE_TYPE.YURT]: "蒙古包",
  [TUJIA_HOUSE_TYPE.STILT_HOUSE]: "吊脚楼",
  [TUJIA_HOUSE_TYPE.WATCHTOWER]: "碉楼",
  [TUJIA_HOUSE_TYPE.CAVE_DWELLING]: "窑洞",
  [TUJIA_HOUSE_TYPE.CABIN]: "木屋",
  [TUJIA_HOUSE_TYPE.TREEHOUSE]: "树屋",
  [TUJIA_HOUSE_TYPE.BAMBOO_HOUSE]: "竹屋",
  [TUJIA_HOUSE_TYPE.TENT]: "帐篷营地",
  [TUJIA_HOUSE_TYPE.YACHT]: "游艇",
  [TUJIA_HOUSE_TYPE.OLD_VILLA]: "老洋房",
  [TUJIA_HOUSE_TYPE.HOTEL_APARTMENT]: "酒店式公寓",
  [TUJIA_HOUSE_TYPE.VILLA_ROOM]: "别墅单间",
  [TUJIA_HOUSE_TYPE.FISHING_ROOM]: "渔家乐",
  [TUJIA_HOUSE_TYPE.BOATHOUSE]: "船屋",
  [TUJIA_HOUSE_TYPE.AGRITAINMENT]: "农家乐",
  [TUJIA_HOUSE_TYPE.INN]: "客栈",
  [TUJIA_HOUSE_TYPE.RESORT]: "度假村",
  [TUJIA_HOUSE_TYPE.CONTAINER]: "集装箱",
  [TUJIA_HOUSE_TYPE.ROCK_HOUSE]: "石屋",
  [TUJIA_HOUSE_TYPE.HANOK]: "韩屋",
  [TUJIA_HOUSE_TYPE.RYOKAN]: "日式旅馆",
  [TUJIA_HOUSE_TYPE.OTHERS]: "其他",
  [TUJIA_HOUSE_TYPE.ATTIC]: "阁楼",
  [TUJIA_HOUSE_TYPE.BEACH_HOUSE]: "海边小屋",
  [TUJIA_HOUSE_TYPE.FOREST_HOUSE]: "林间小屋",
  [TUJIA_HOUSE_TYPE.CASTLE]: "城堡",
};

// 房源空间类型
export enum HOUSE_SPACE_TYPE {
  ALL = 1, // 整套房源
  ALONE = 2, // 独立房间
  // SHARE = 3 // 合住房间
}

export const HOUSE_SPACE_TYPE_DESC: Record<HOUSE_SPACE_TYPE, string> = {
  [HOUSE_SPACE_TYPE.ALL]: "整套房源",
  [HOUSE_SPACE_TYPE.ALONE]: "独立单间",
  // [HOUSE_SPACE_TYPE.SHARE]  : '合住房间',
};

// 床单更换频率
export enum BED_SHEET_CHANGE {
  GUEST = 1, // 每客一换
  DAY = 2, // 每日一换
}

export const BED_SHEET_CHANGE_DESC = {
  [BED_SHEET_CHANGE.GUEST]: "一客一扫/换",
  [BED_SHEET_CHANGE.DAY]: "一天一扫/换",
};

// 订单取消规则
export enum CANCEL_RULE {
  LOOSE = 0, // 规则宽松
  MIDDLE = 1, // 规则中等
  STRICT = 2, // 规则严格
}

export const CANCEL_RULE_DESC = {
  [CANCEL_RULE.LOOSE]: "灵活：入住的1天前取消预订可获全额退款",
  [CANCEL_RULE.MIDDLE]: "适中：入住的7天前取消预订可获全额退款",
  [CANCEL_RULE.STRICT]: "严格：入住的7天前取消预订可获50%退款",
};

// 床型
export const BED_TYPE_DESC = {
  king_bed: "特大床",
  queen_bed: "大床",
  double_bed: "双人床",
  single_bed: "单人床",
  sofa_bed: "沙发床",
  couch_bed: "沙发",
  bunk_bed: "双层床",
  floor_mattress: "放在地上的床垫",
  air_mattress: "充气床垫",
  crib_bed: "婴儿床",
  toddler_bed: "幼儿床",
  hammock_bed: "吊床",
  water_bed: "水床",
  futon_bed: "榻榻米",
  round_bed: "圆床",
  double_couch_bed: "双人沙发床",
  children_bed: "儿童床",
  double_children_bed: "儿童双层床",
  kang_bed: "炕",
};


export const PRICE_RANGE = {
  [PLATFORM_TYPE.AIRBNB]: {
    currency: "USD",
    min: 10,
    max: 25000,
  },
  [PLATFORM_TYPE.ZHENGUO]: {
    currency: "CNY",
    min: 10,
    max: 50000,
  },
  [PLATFORM_TYPE.TUJIA]: {
    currency: "CNY",
    min: 0,
    max: 50000,
  },
  [PLATFORM_TYPE.TUJIAGYS]: {
    currency: "CNY",
    min: 0,
    max: 50000,
  },
  [PLATFORM_TYPE.XIAOZHU]: {
    currency: "CNY",
    min: 0,
    max: 99999,
  },
  [PLATFORM_TYPE.YIJIA]: {
    currency: "CNY",
    min: 50,
    max: 30000,
  },
  [PLATFORM_TYPE.MUNIAO]: {
    currency: "CNY",
    min: 50,
    max: 30000,
  },
  [PLATFORM_TYPE.SHOP]: {
    currency: "CNY",
    min: 0,
    max: 50000,
  },
};

// 币种
export const CURRENCIES = [
  { value: "CNY", name: "人民币", unit: "￥" },
  { value: "JPY", name: "日元", unit: "￥" },
  { value: "USD", name: "美元", unit: "$" },
  { value: "THB", name: "泰铢", unit: "฿" },
];

// 收入支出项目
export const TRANSACTION_ITEMS = [
  { name: "其他", value: 0, name_en: "others" },
  { name: "人工费用", value: 1, name_en: "labour" },
  { name: "日常用品", value: 2, name_en: "supplies" },
  { name: "生活缴费", value: 3, name_en: "payment" },
  { name: "装修维护", value: 4, name_en: "decoration" },
  { name: "房屋租金", value: 5, name_en: "rent" },
  { name: "线下房费", value: 6, name_en: "charge_offline" },
  { name: "线上房费", value: 7, name_en: "charge_online" },
];
// 付款方式
export const PAY_METHODS = [
  { name: "其他", value: 0 },
  { name: "支付宝", value: 1 },
  { name: "微信", value: 2 },
  { name: "银行转账", value: 3 },
  { name: "现金", value: 4 },
];

export enum MESSAGE_TYPE {
  /** 询问房子 */
  HOUSE = "House",
  /** 预准 */
  SPECIAL_OFFER = "SpecialOffer",
  FILE_ATTACHMENT = "FileAttachment",
  INQUIRY_RESERVATION = "InquiryReservation",
  RESERVATION_ALTERATION = "ReservationAlteration",
  RESOLUTION = "Resolution",
}

/** will @deprecated 角色的能力 */
export const ROLE_ABILITY = {
  workbench: "工作台",
  tenant_interaction: "消息",
  calendar: "房态",
  house_list: "房间",
  reservation_list: "订单",
  finance_statistics: "财务明细",
  operation_statistics: "运营统计",
  a_balance_of_payments: "记账",
  shop_manage: "微店管理",
  thirdparty: "渠道账号管理",
  system_message: "系统消息",
  bank_account: "收款账户",
  tujia_shop_message: "途家门店",
  payment_record: "结算记录",
};

/** 国内版 only */
export const BANK_LIST = [
  { value: "CDB", name: "国家开发银行" },
  { value: "ICBC", name: "中国工商银行" },
  { value: "ABC", name: "中国农业银行" },
  { value: "BOC", name: "中国银行" },
  { value: "CCB", name: "中国建设银行" },
  { value: "PSBC", name: "中国邮政储蓄银行" },
  { value: "COMM", name: "交通银行" },
  { value: "CMB", name: "招商银行" },
  { value: "SPDB", name: "上海浦东发展银行" },
  { value: "CIB", name: "兴业银行" },
  { value: "HXBANK", name: "华夏银行" },
  { value: "GDB", name: "广东发展银行" },
  { value: "CMBC", name: "中国民生银行" },
  { value: "CITIC", name: "中信银行" },
  { value: "CEB", name: "中国光大银行" },
  { value: "EGBANK", name: "恒丰银行" },
  { value: "CZBANK", name: "浙商银行" },
  { value: "BOHAIB", name: "渤海银行" },
  { value: "SPABANK", name: "平安银行" },
  { value: "SHRCB", name: "上海农村商业银行" },
  { value: "YXCCB", name: "玉溪市商业银行" },
  { value: "YDRCB", name: "尧都农商行" },
  { value: "BJBANK", name: "北京银行" },
  { value: "SHBANK", name: "上海银行" },
  { value: "JSBANK", name: "江苏银行" },
  { value: "HZCB", name: "杭州银行" },
  { value: "NJCB", name: "南京银行" },
  { value: "NBBANK", name: "宁波银行" },
  { value: "HSBANK", name: "徽商银行" },
  { value: "CSCB", name: "长沙银行" },
  { value: "CDCB", name: "成都银行" },
  { value: "CQBANK", name: "重庆银行" },
  { value: "DLB", name: "大连银行" },
  { value: "NCB", name: "南昌银行" },
  { value: "FJHXBC", name: "福建海峡银行" },
  { value: "HKB", name: "汉口银行" },
  { value: "WZCB", name: "温州银行" },
  { value: "QDCCB", name: "青岛银行" },
  { value: "TZCB", name: "台州银行" },
  { value: "JXBANK", name: "嘉兴银行" },
  { value: "CSRCB", name: "常熟农村商业银行" },
  { value: "NHB", name: "南海农村信用联社" },
  { value: "CZRCB", name: "常州农村信用联社" },
  { value: "H3CB", name: "内蒙古银行" },
  { value: "SXCB", name: "绍兴银行" },
  { value: "SDEB", name: "顺德农商银行" },
  { value: "WJRCB", name: "吴江农商银行" },
  { value: "ZBCB", name: "齐商银行" },
  { value: "GYCB", name: "贵阳市商业银行" },
  { value: "ZYCBANK", name: "遵义市商业银行" },
  { value: "HZCCB", name: "湖州市商业银行" },
  { value: "DAQINGB", name: "龙江银行" },
  { value: "JINCHB", name: "晋城银行JCBANK" },
  { value: "ZJTLCB", name: "浙江泰隆商业银行" },
  { value: "GDRCC", name: "广东省农村信用社联合社" },
  { value: "DRCBCL", name: "东莞农村商业银行" },
  { value: "MTBANK", name: "浙江民泰商业银行" },
  { value: "GCB", name: "广州银行" },
  { value: "LYCB", name: "辽阳市商业银行" },
  { value: "JSRCU", name: "江苏省农村信用联合社" },
  { value: "LANGFB", name: "廊坊银行" },
  { value: "CZCB", name: "浙江稠州商业银行" },
  { value: "DYCB", name: "德阳商业银行" },
  { value: "JZBANK", name: "晋中市商业银行" },
  { value: "BOSZ", name: "苏州银行" },
  { value: "GLBANK", name: "桂林银行" },
  { value: "URMQCCB", name: "乌鲁木齐市商业银行" },
  { value: "CDRCB", name: "成都农商银行" },
  { value: "ZRCBANK", name: "张家港农村商业银行" },
  { value: "BOD", name: "东莞银行" },
  { value: "LSBANK", name: "莱商银行" },
  { value: "BJRCB", name: "北京农村商业银行" },
  { value: "TRCB", name: "天津农商银行" },
  { value: "SRBANK", name: "上饶银行" },
  { value: "FDB", name: "富滇银行" },
  { value: "CRCBANK", name: "重庆农村商业银行" },
  { value: "ASCB", name: "鞍山银行" },
  { value: "NXBANK", name: "宁夏银行" },
  { value: "BHB", name: "河北银行" },
  { value: "HRXJB", name: "华融湘江银行" },
  { value: "ZGCCB", name: "自贡市商业银行" },
  { value: "YNRCC", name: "云南省农村信用社" },
  { value: "JLBANK", name: "吉林银行" },
  { value: "DYCCB", name: "东营市商业银行" },
  { value: "KLB", name: "昆仑银行" },
  { value: "ORBANK", name: "鄂尔多斯银行" },
  { value: "XTB", name: "邢台银行" },
  { value: "JSB", name: "晋商银行" },
  { value: "TCCB", name: "天津银行" },
  { value: "BOYK", name: "营口银行" },
  { value: "JLRCU", name: "吉林农信" },
  { value: "SDRCU", name: "山东农信" },
  { value: "XABANK", name: "西安银行" },
  { value: "HBRCU", name: "河北省农村信用社" },
  { value: "NXRCU", name: "宁夏黄河农村商业银行" },
  { value: "GZRCU", name: "贵州省农村信用社" },
  { value: "FXCB", name: "阜新银行" },
  { value: "HBHSBANK", name: "湖北银行黄石分行" },
  { value: "ZJNX", name: "浙江省农村信用社联合社" },
  { value: "XXBANK", name: "新乡银行" },
  { value: "HBYCBANK", name: "湖北银行宜昌分行" },
  { value: "LSCCB", name: "乐山市商业银行" },
  { value: "TCRCB", name: "江苏太仓农村商业银行" },
  { value: "BZMD", name: "驻马店银行" },
  { value: "GZB", name: "赣州银行" },
  { value: "WRCB", name: "无锡农村商业银行" },
  { value: "BGB", name: "广西北部湾银行" },
  { value: "GRCB", name: "广州农商银行" },
  { value: "JRCB", name: "江苏江阴农村商业银行" },
  { value: "BOP", name: "平顶山银行" },
  { value: "TACCB", name: "泰安市商业银行" },
  { value: "CGNB", name: "南充市商业银行" },
  { value: "CCQTGB", name: "重庆三峡银行" },
  { value: "XLBANK", name: "中山小榄村镇银行" },
  { value: "HDBANK", name: "邯郸银行" },
  { value: "KORLABANK", name: "库尔勒市商业银行" },
  { value: "BOJZ", name: "锦州银行" },
  { value: "QLBANK", name: "齐鲁银行" },
  { value: "BOQH", name: "青海银行" },
  { value: "YQCCB", name: "阳泉银行" },
  { value: "SJBANK", name: "盛京银行" },
  { value: "FSCB", name: "抚顺银行" },
  { value: "ZZBANK", name: "郑州银行" },
  { value: "SRCB", name: "深圳农村商业银行" },
  { value: "BANKWF", name: "潍坊银行" },
  { value: "JJBANK", name: "九江银行" },
  { value: "JXRCU", name: "江西省农村信用" },
  { value: "HNRCU", name: "河南省农村信用" },
  { value: "GSRCU", name: "甘肃省农村信用" },
  { value: "SCRCU", name: "四川省农村信用" },
  { value: "GXRCU", name: "广西省农村信用" },
  { value: "SXRCCU", name: "陕西信合" },
  { value: "WHRCB", name: "武汉农村商业银行" },
  { value: "YBCCB", name: "宜宾市商业银行" },
  { value: "KSRB", name: "昆山农村商业银行" },
  { value: "SZSBK", name: "石嘴山银行" },
  { value: "HSBK", name: "衡水银行" },
  { value: "XYBANK", name: "信阳银行" },
  { value: "NBYZ", name: "鄞州银行" },
  { value: "ZJKCCB", name: "张家口市商业银行" },
  { value: "XCYH", name: "许昌银行" },
  { value: "JNBANK", name: "济宁银行" },
  { value: "CBKF", name: "开封市商业银行" },
  { value: "WHCCB", name: "威海市商业银行" },
  { value: "HBC", name: "湖北银行" },
  { value: "BOCD", name: "承德银行" },
  { value: "BODD", name: "丹东银行" },
  { value: "JHBANK", name: "金华银行" },
  { value: "BOCY", name: "朝阳银行" },
  { value: "LSBC", name: "临商银行" },
  { value: "BSB", name: "包商银行" },
  { value: "LZYH", name: "兰州银行" },
  { value: "BOZK", name: "周口银行" },
  { value: "DZBANK", name: "德州银行" },
  { value: "SCCB", name: "三门峡银行" },
  { value: "AYCB", name: "安阳银行" },
  { value: "ARCU", name: "安徽省农村信用社" },
  { value: "HURCB", name: "湖北省农村信用社" },
  { value: "HNRCC", name: "湖南省农村信用社" },
  { value: "NYNB", name: "广东南粤银行" },
  { value: "LYBANK", name: "洛阳银行" },
  { value: "NHQS", name: "农信银清算中心" },
  { value: "CBBQS", name: "城市商业银行资金清算中心" },
];

export enum PAY_EDITION {
  EDITION_FREE = 0, // 免费版，默认版本
  EDITION_TRIAL = 1, // 体验版
  EDITION_PROFESSIONAL = 2, // 专业版
  EDITION_ENTERPRISE = 3, // 企业版
}

export const OVERSEAS_EDITION_DATE_FORMAT_V2 = [
  // Y-M-D
  { value: 0, ymd: "YYYY-MM-DD", ym: "YYYY-MM", md: "MM-DD" },
  { value: 1, ymd: "YYYY/MM/DD", ym: "YYYY/MM", md: "MM/DD" },
  { value: 10, ymd: "YYYY.MM.DD", ym: "YYYY.MM", md: "MM.DD" },
  { value: 11, ymd: "YYYY MMM DD", ym: "YYYY MMM", md: "MMM DD" },
  // Y-D-M
  { value: 12, ymd: "YYYY-DD-MM", ym: "YYYY MMM", md: "DD-MM" },
  { value: 13, ymd: "YYYY/DD/MM", ym: "YYYY MMM", md: "DD/MM" },
  { value: 14, ymd: "YYYY.DD.MM", ym: "YYYY MMM", md: "DD.MM" },
  { value: 15, ymd: "YYYY DD MMM", ym: "YYYY MMM", md: "DD MMM" },
  // M-D-Y
  { value: 2, ymd: "MM-DD-YYYY", ym: "MMM YYYY", md: "MM-DD" },
  { value: 3, ymd: "MM/DD/YYYY", ym: "MMM YYYY", md: "MM/DD" },
  { value: 16, ymd: "MM.DD.YYYY", ym: "MMM YYYY", md: "MM.DD" },
  { value: 4, ymd: "MMM DD YYYY", ym: "MMM YYYY", md: "MMM DD" },
  // D-M-Y
  { value: 6, ymd: "DD-MM-YYYY", ym: "MMM YYYY", md: "DD-MM" },
  { value: 7, ymd: "DD/MM/YYYY", ym: "MMM YYYY", md: "DD/MM" },
  { value: 17, ymd: "DD.MM.YYYY", ym: "MMM YYYY", md: "DD.MM" },
  { value: 8, ymd: "DD MMM YYYY", ym: "MMM YYYY", md: "DD MMM" },
];

export const OVERSEAS_EDITION_TIME_FORMAT_V2 = [
  { value: 0, hms: "HH:mm:ss", hm: "HH:mm", ms: "mm:ss" },
  { value: 1, hms: "hh:mm:ss a", hm: "hh:mm a", ms: "mm:ss" },
];

export enum OVERSEAS_EDITION_TIME_FORMAT {
  HOUR_TWENTY_FOUR = 0, // 24小时制
  HOUR_TWELVE = 1, // 12小时制
}

export const CREDENTIAL_TYPE = [
  { value: "id_card", name: "身份证", i18nName: "guest.list.id_card" },
  { value: "passport", name: "护照", i18nName: "guest.list.passport" },
  {
    value: "gang_ao_tai_card",
    name: "港澳台证件",
    i18nName: "guest.list.exit_entry_permit",
  },
  {
    value: "serviceman_card",
    name: "军人证",
    i18nName: "guest.list.military_id",
  },
];

/**
 * 权限和路由的映射
 * */
export const PERMISSION_ROUTE_MAP = {
  tenant_interaction: ["/app/messages"],
  reservation_list: ["/app/reservations"],
  calendar: ["/app/calendar", "/app/rates/calendar"],
  house_list: ["/app/properties"],
  income_outcome_detail: ["/app/statistics/payment-detail"],
  income_outcome_struct: ["/app/statistics/payment-structure"],
  business_data: ["/app/statistics/operate"],
  shop_manage: ["/app/shop/list"],
  // thirdparty: ['/app/settings']
};

// --------------------------
// ---------通用函数----------
// --------------------------

/**
 * @deprecated
 * todo: 多余的函数，待删除
 * 日期比较函数 -- 起始日期是否在结束日期之后
 * @param start Date | string | Moment
 * @param end Date | string | Moment
 */
export function isStartDateAfterEndDate(start, end) {
  if (!start || !end) {
    return false;
  }
  return moment(start).isAfter(moment(end), "day");
}
export const MAX_AMOUNT = 999999999; // todo: 命名含义不明，待修改


//#region 全局配置服务
export interface AuthConfig {
  login_url?: string;
};
export interface ACLConfig {
  guard_url?: string;
}

export interface IGlobalConfig {
  auth?: AuthConfig;
  acl?: ACLConfig;
};
export const GLOBAL_CONFIG_TOKEN = new InjectionToken<IGlobalConfig>('GLOBAL_CONFIG_TOKEN');
export const GlobalConfig: IGlobalConfig = {
  auth: { login_url: '/app/login' }
};
//#endregion

//#region 全局通用函数
// log，带颜色输出
export type IColorLog = (message: string, color?: string) => void;
export const LOG_SERVICE_TOKEN = new InjectionToken<IColorLog>('LOG_SERVICE_TOKEN', {
  providedIn: 'root',
  factory: () => {
    return (message: string, color = '#2c80f0') => {
      console.log(
        '%c' + message,
        'background-color: #d3d7d4; padding-left: 4px; padding-right: 4px; border-radius: 4px; font-weight: bold; font-size: 12px; color: ' + color);
    }
  }
})
//#endregion

